export default "__VITE_ASSET__HZBG4d7V__"